import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import isEmpty from "lodash/isEmpty";

import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";

export const ShippingCostEstimatesIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    additionalRequiredData: [ShippingContextDataFn],
  };
};

const getAnswer = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  const { shippingContext } = context;
  if (!shippingContext || isEmpty(shippingContext.shipments)) {
    return ORDER_NOT_SHIPPED(strictLocalize);
  }

  return shippingContext.estimated_shipping_cost
    ? ESTIMATES_INCLUDED_IN_ORDER_SHIPPED(strictLocalize)
    : ESTIMATES_NOT_INCLUDED_IN_ORDER_SHIPPED(strictLocalize);
};

const ORDER_NOT_SHIPPED = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => ({
  getTitle: () => WHAT_ARE_SHIPPING_ESTIMATES(strictLocalize),
  getDescription: () => [
    ESTIMATED_SHIPPING_COST_PROVIDED_AT_CHECKOUT_IF_AVAILABLE(strictLocalize),
  ],
});

const ESTIMATES_INCLUDED_IN_ORDER_SHIPPED = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => ({
  getTitle: () => WHAT_ARE_SHIPPING_ESTIMATES(strictLocalize),
  getDescription: () => [
    ESTIMATED_SHIPPING_COST_PROVIDED_AT_CHECKOUT(strictLocalize),
  ],
});

const ESTIMATES_NOT_INCLUDED_IN_ORDER_SHIPPED = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => ({
  getTitle: () => SHIPPING_COST_FINALIZED(strictLocalize),
  getDescription: () => [
    SHIPPING_COST_FINALIZED_AFTER_ORDER_IS_SHIPPED(strictLocalize),
  ],
});

const WHAT_ARE_SHIPPING_ESTIMATES = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "What are shipping estimates?",
    description: {
      text: "Title for the answer of understanding shipping cost estimates issue if the selected order has not shipped or has shipped but estimated shipping cost was provided",
    },
  });

const ESTIMATED_SHIPPING_COST_PROVIDED_AT_CHECKOUT_IF_AVAILABLE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "If available, we provide an estimated shipping cost at checkout. The final cost of shipping is finalized after your order is shipped and is reflected on your invoice.",
  });

const ESTIMATED_SHIPPING_COST_PROVIDED_AT_CHECKOUT = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "At checkout, we provided an estimated shipping cost. The final cost of shipping is finalized after your order is shipped and is reflected on your invoice.",
  });

const SHIPPING_COST_FINALIZED = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Your shipping cost has been finalized",
    description: {
      text: "Title for the answer of understanding shipping cost estimates issue if the selected order has shipped and estimated shipping cost was not provided",
    },
  });
const SHIPPING_COST_FINALIZED_AFTER_ORDER_IS_SHIPPED = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "The final cost of shipping is finalized after your order is shipped and is reflected on your invoice.",
  });
